module.exports = __webpack_public_path__ + "media/images/benefit-04-a8c78d450c8e64c175fa6d48fb9103de.svg";